import React from "react";

import { Client, Server } from "styletron-engine-atomic";
import { Provider as StyletronProvider } from "styletron-react";
import { BaseProvider, createTheme, LightTheme } from "baseui";

const getHydrateClass = () =>
  document.getElementsByClassName(
    "_styletron_hydrate_"
  ) as HTMLCollectionOf<HTMLStyleElement>;

const primitives = {
  primary: "#38583E",
  primary50: "#4D6B47",
  primary100: "#697F4F",
  primary200: "#A9CC76",
  primary300: "#B4C39B",
  primary400: "#D5E1A4",
  primary500: "#F9F0DD",
  primary600: "#ffffff",
  accent: "#31371e",
  accent50: "#4c5729",
  accent100: "#83906D",
  accent200: "#F89FF3",
  accent300: "#F45AEA",
  accent400: "#F127E4",
  accent500: "#B71DAD",
  accent600: "#f2f2f2",
  accent700: "#dbdbdb",
};

const theme = createTheme(primitives, {
  colors: {
    buttonSecondaryFill: primitives.primary100,
    buttonSecondaryText: primitives.primary600,
    buttonSecondaryHover: primitives.primary200,
    buttonSecondaryActive: primitives.accent300,
    buttonSecondarySelectedFill: primitives.accent200,
    buttonSecondarySelectedText: primitives.accent,
    buttonSecondarySpinnerForeground: primitives.accent700,
    buttonSecondarySpinnerBackground: primitives.accent300,
    buttonPrimaryFill: primitives.primary,
    buttonPrimaryText: primitives.primary600,
    buttonPrimaryHover: primitives.primary50,
  },
  typography: {
    font100: {
      fontFamily: '"Poppins", sans-serif',
      fontSize: "12px",
      fontWeight: "normal",
      lineHeight: "16px",
    },
    font650: {
      fontFamily: '"Poppins", sans-serif',
      fontSize: "12px",
      fontWeight: "600",
      lineHeight: "16px",
    },
  },
  breakpoints: {
    small: "350px",
    medium: "768px",
    large: "1280px",
  },
});

const engine =
  typeof window === "undefined"
    ? new Server()
    : new Client({
        hydrate: getHydrateClass(),
      });

type ContainerProps = {
  children: React.ReactNode;
};

export const Theme: React.FC<ContainerProps> = ({
  children,
}: ContainerProps) => (
  <StyletronProvider value={engine}>
    <BaseProvider theme={theme}>{children}</BaseProvider>
  </StyletronProvider>
);
